import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';

/**
 * Firebase web config for Kinvera (dorc-481715).
 * These are public client identifiers from the Firebase console — not server secrets.
 * VITE_FIREBASE_* env vars override individual fields when set at build time.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBGn5U8vVFq2Sleg83_bXnycLnGpAgMQdc',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'dorc-481715.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'dorc-481715',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'dorc-481715.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '1092170595100',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:1092170595100:web:0e51d85ffba41e8ca658d9',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-Z15QR2HBGV',
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId
);

export const app: FirebaseApp = initializeApp(firebaseConfig);
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);

/** Analytics only when the browser supports it (safe for Vite SPA; no SSR). */
export const analyticsPromise: Promise<Analytics | null> = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null);
